<freud-dialog [header]="'PROMPTUARY.QUALITY_MODAL.TITLE' | translate" [modal]="true" [(visible)]="isVisible">
	<p id="quality-description-text" freud-typography freud-typography fontType="bodyRegular1-5">
		{{ 'PROMPTUARY.QUALITY_MODAL.DESCRIPTION' | translate }}
	</p>
	<div id="quality-steps-first" class="zk-flex zk-items-center zk-gap-2 zk-pt-4">
		<freud-avatar size="sm" label="1"></freud-avatar>
		<p freud-typography fontType="bodyRegular1-5">
			{{ 'PROMPTUARY.QUALITY_MODAL.STEPS.FIRST' | translate }}
		</p>
	</div>
	<div id="quality-steps-second" class="zk-flex zk-items-center zk-gap-2 zk-pt-4">
		<freud-avatar size="sm" label="2"></freud-avatar>
		<p freud-typography fontType="bodyRegular1-5">
			{{ 'PROMPTUARY.QUALITY_MODAL.STEPS.SECOND' | translate }}
		</p>
	</div>
	<div id="quality-steps-third" class="zk-flex zk-gap-2 zk-pt-4 zk-mb-4 zk-items-baseline">
		<freud-avatar size="sm" label="3"></freud-avatar>
		<p freud-typography fontType="bodyRegular1-5">
			{{ 'PROMPTUARY.QUALITY_MODAL.STEPS.THIRD' | translate }}
		</p>
	</div>

	<promptuary-quality-description [isOpen]="true"></promptuary-quality-description>
	
	<div class="zk-flex zk-pt-4 zk-items-center quality-modal-footer">
		<freud-checkbox
			[(ngModel)]="shouldHideModal"
			[label]="'PROMPTUARY.QUALITY_MODAL.HIDE_MODAL_CHECKBOX_TEXT' | translate"
		></freud-checkbox>
		<div class="zk-flex zk-gap-2">
			<freud-button id="more-about-button" color="ghost" (click)="goToMoreAboutQualityPage()">{{ 'PROMPTUARY.QUALITY_MODAL.MORE_ABOUT.TEXT' | translate }}</freud-button>
			<freud-button id="close-modal-button" (click)="closeModal()">{{ 'PROMPTUARY.QUALITY_MODAL.HIDE_MODAL_BUTTON_TEXT' | translate }}</freud-button>	
		</div>
	</div>
</freud-dialog>